import { getReadableErrorMessage } from "../shared/utils/errorMessageMappings";

/** @deprecated Use getReadableErrorMessage from utils/errorMessageMappings instead. Kept for backward compatibility. */
export const takeReadAbelError = getReadableErrorMessage;
